import { render } from "./LoadingBox.vue?vue&type=template&id=60a2fe69&scoped=true"
import script from "./LoadingBox.vue?vue&type=script&lang=js"
export * from "./LoadingBox.vue?vue&type=script&lang=js"

import "./LoadingBox.vue?vue&type=style&index=0&id=60a2fe69&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a2fe69"],['__file',"src/components/helpers/LoadingBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60a2fe69"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60a2fe69', __exports__)) {
    api.reload('60a2fe69', __exports__)
  }
  
  module.hot.accept("./LoadingBox.vue?vue&type=template&id=60a2fe69&scoped=true", () => {
    api.rerender('60a2fe69', render)
  })

}


export default __exports__